// Purpose: render button elements for popup forms
define([
  'react',
  'prop-types',
  'immutable',
  'underscore',
  'es6!sumo/util',
  'es6!launcher/util/listbuilder/constants',
  'jsx!launcher/views/listbuilder/wysiwyg/components/Component',
], (React, PropTypes, Immutable, _, Util, Constants, Component) => {
  const WRAPPER_STYLE_ATTRS = [
    'borderTopLeftRadius',
    'borderTopRightRadius',
    'borderBottomRightRadius',
    'borderBottomLeftRadius',
    'height',
  ];

  const STYLE_ATTRS = [
    'borderTopLeftRadius',
    'borderTopRightRadius',
    'borderBottomRightRadius',
    'borderBottomLeftRadius',
    'backgroundColor',
    'height',
  ];

  @Component()
  class ProgressBar extends React.Component {
    render() {
      const {
        progress,
      } = this.props;

      const style = _.pick(this.props.style.toJS(), STYLE_ATTRS);
      const progressStyle = {
        ...style,
        width: `${progress}%`,
      };

      if (progress === 0) {
        progressStyle.display = 'none';
      }

      const wrapperStyle = _.pick(this.props.style.toJS(), WRAPPER_STYLE_ATTRS);

      return (
        <div className="sumo-progress-bar-wrapper" style={wrapperStyle}>
          <div className="sumo-progress-bar" style={progressStyle} />
        </div>
      );
    }
  }

  ProgressBar.propTypes = {
    progress: PropTypes.number.isRequired,
    style: PropTypes.instanceOf(Immutable.Map).isRequired,
  };

  return ProgressBar;
});
